import { useQuery } from "@tanstack/vue-query"
import type { TransactionStatus } from "../sharedTypes/transactions"
import { api } from "@/api"

export type ListMerchantGroupLastFiveTransactionsResponseItem =
  {
    id: string
    invoiceId: string
    type: "payment" | "refund"
    createdAt: Date
    status: TransactionStatus
    amountTransactedGross: number
    amountTransactedTotal: number
    transactionMethod: "pos_cash" | "pos_card"
    cardScheme: string | null
    cardNumberLast4: string | null
    source: "donation" | "sale" | "unlinked"
    sourceNumber: number | null
    currency: string
    merchantName: string
  }

export const listMerchantGroupLastFiveTransactions =
  async () => {
    const { body } = await api.get<
      Array<
        RecursivelyConvertDatesToStrings<ListMerchantGroupLastFiveTransactionsResponseItem>
      >
    >("/merchant-group/last-five-transactions/", {
      isMerchantGroup: true,
    })

    return body.map((transaction) => ({
      ...transaction,
      createdAt: DateFns.parseISO(transaction.createdAt),
    }))
  }

export const useMerchantGroupLastFiveTransactions = () =>
  useQuery({
    queryKey: [
      BASE_MERCHANT_GROUP_LAST_FIVE_TRANSACTIONS_QUERY_KEY,
    ] as const,
    queryFn: () => listMerchantGroupLastFiveTransactions(),
    refetchInterval: 60 * 1000,
    staleTime: 0,
  })
